module.exports = __webpack_public_path__ + "img/37.b34d327a.jpg";